<template>
  <section>
    <PageTitle>
      <span v-html="$store.getters['app/getMenuName']('collage')" />
    </PageTitle>
    <div>
      <PageContent v-if="!hasCollage">
        <Container>
          <NoticeBox
            type="error"
            :borderless="true"
            class="space-b-2 text-bold"
          >
            現在、コラージュ画像がありません
          </NoticeBox>
          <p class="text-paragraph text-xs">
            現在表示されるコラージュ画像がありません。
            <br class="mobile-only" />
            コラージュ画像がある場合は、この画面に表示されます。
          </p>
          <div class="text-center space-t-6">
            <router-link
              :to="$wcRouter.path({ name: 'index' })"
              class="button waves-effect waves-light"
            >
              TOPへ
            </router-link>
          </div>
        </Container>
      </PageContent>
      <PageContent v-else>
        <Container>
          <div class="collage-content">
            <div class="collage-image-box" ref="collageImageBox">
              <!-- タイポグラフィ用の要素 -->
              <div class="collage-groom-bride-name">
                <p>
                  <span class="collage-groom-name">{{ $domUtils.decode(business.groom_first_name_romaji) }}</span>
                  <span class="collage-ampersand">&</span>
                  <span class="collage-bride-name">{{ $domUtils.decode(business.bride_first_name_romaji) }}</span>
                </p>
                <p>
                  <span class="collage-ceremony-date">
                    {{ $domUtils.decode(business.ceremony_date) }}
                  </span>
                </p>
              </div>
              <figure
                v-for="collage in collageList"
                :key="collage.bridal_item_subgroup_id"
                :class="[
                  'collage-item',
                  `collage-box-${collage.bridal_item_subgroup_id} `,
                ]"
              >
                <img
                  v-if="hasCollageImage(collage)"
                  class="collage-image"
                  :src="collage.image_url"
                />
                <figcaption
                  v-if="hasCollageImage(collage)"
                  class="collage-bridal-item-subgroup-name"
                >
                  {{ $domUtils.decode(collage.bridal_item_subgroup_name) }}
                </figcaption>
              </figure>
            </div>
            <i
              class="fas fa-download text-primary fa-2x"
              v-on:click="downloadCollageImage"
            ></i>
            <p class="collage-download-comment text-paragraph text-xs">
              ダウンロードできない場合は、スクリーンショットを保存して下さい。
            </p>
          </div>
          <div class="text-center space-t-3" v-if="history">
              <a href="#" @click.prevent="$router.back()">
                前の画面へ戻る
              </a>
          </div>
        </Container>
      </PageContent>
    </div>
  </section>
</template>
<script>
import NoticeBox from '@/components/NoticeBox.vue'
import businessApi from "@/api/business"
import collageApi from "@/api/collage"
import { renderError } from "@/utils/error"
import html2canvas from "html2canvas"
import { formatYmdhmsStr } from "@/filters/format-date"
import moment from 'moment'

export default {
  components: {
    NoticeBox
  },
  metaInfo() {
    return {
      title: this.$store.state.app.pageName,
      bodyAttrs: {
        class: "collage " + this.office_class + this.coordinate_class,
      },
    }
  },
  data() {
    return {
      business: [],
      collageList: [],
      office_class: "",
      coordinate_class: "",
      history: false
    }
  },
  computed: {
    businessId() {
      return this.$store.getters["auth/businessId"]
    },
    isCustomer() {
      return this.$store.getters["auth/isCustomer"]
    },
    idParam() {
      return this.$route.params.id
    },
    hasCollage() {
      // コラージュ対象の婚礼アイテムが1つ以上存在するかどうか
      return this.collageList.filter(
        item => item.image_url !== ''
      ).length > 0
    },
    hasCollageImage() {
      // コラージュ画像存在するかどうか
      return function(collage) {
          return collage.image_url !== ''
      }
    },
  },
  methods: {
    async fetchBusiness() {
      try {
        this.business = await businessApi.get(this.businessId)
        this.business.ceremony_date = moment(this.business.ceremony_date).format('YYYY.MM.DD')
      } catch (err) {
        renderError(err)
      }
    },
    async fetchHistoryCollage() {
      try {
        const result = await collageApi.getHistory(this.businessId, this.idParam)
        if (result !== null) this.initCollage(result)
      } catch (err) {
        renderError(err)
      }
    },
    async fetchLatestCollage() {
      try {
        const result = await collageApi.getLatest(this.businessId)
        if (result !== null) this.initCollage(result)
      } catch (err) {
        renderError(err)
      }
    },
    initCollage(result) {
      this.collageList = result.bridal_item_list
      if (this.hasCollage) {
        // コラージュのアイテムがある場合にのみclassを生成する
        this.office_class = "collage-office-" + result.office_id
        let coordinateClass = ""
        const coordinateList = result.coordinate_list
        // CSSによる調整を行うためコーディネートIDを基にclassを生成する
        for (const coordinate of coordinateList) {
          const coordinateId = coordinate.coordinate_id
          coordinateClass += " collage-coordinate-" + coordinateId
        }
        this.coordinate_class = coordinateClass
      }
    },
    async downloadCollageImage() {
      html2canvas(this.$refs.collageImageBox, {
        height: this.$refs.collageImageBox.clientHeight - 1,
        width: this.$refs.collageImageBox.clientWidth - 1
      }).then(
        (canvas) => {
          const link = document.createElement("a")
          link.href = canvas.toDataURL()
          const nowDatetime = formatYmdhmsStr(new Date())
          // 新郎新婦、新郎新婦以外でファイル名を分岐
          const fileName = this.isCustomer
            ? "コラージュ_" + nowDatetime + ".png"
            : "コラージュ_" + this.businessId + "_" + nowDatetime + ".png"
          link.download = fileName
          link.click()
        }
      )
    },
  },
  created() {
    if (typeof this.idParam !== 'undefined') {
      // URLパラメータに見積履歴IDを持つ場合
      this.history = true
      this.$withLoading(() =>
        Promise.all([this.fetchBusiness(), this.fetchHistoryCollage()])
      )
    } else {
      this.$withLoading(() =>
        Promise.all([this.fetchBusiness(), this.fetchLatestCollage()])
      )
    }
  },
  watch: {
    $route(value) {
      this.fetchBusiness()
      if (typeof value.params.id !== 'undefined') {
        // URLパラメータに見積履歴IDを持つ場合
        this.history = true
        this.fetchHistoryCollage()
      } else {
        this.history = false
        this.fetchLatestCollage()
      }
    }
  }
}
</script>